import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  onGetSearchResult,
  setCertificateDetails,

} from '../../../config/redux/slice/bankUserSlice'
import {
  onGetSearchResult as onGetSearchResultT,
  setCertificateDetails as setCertificateDetailsT,

} from '../../../config/redux/slice/transfereeUserSlice'
import {
  onGetSearchResult as onGetSearchResultN,
  setCertificateDetails as setCertificateDetailsN,
} from '../../../config/redux/slice/notapUserSlice'
import { certicatesDatatable as searchResultDatatable } from '../../../helpers/dataTables'
import { getRequest } from '../../../helpers/request'
import { appApi } from '../../../utils/endpoints/appApi'
import { appUrls } from '../../../utils/urls/appUrls'
import { DataTableWrapper } from '../../components'
import BankWrapper from '../../layout/BankWrapper'
import TransfereeWrapper from '../../layout/TransfereeWrapper'
import AddCommentForm from '../CertificateManagement/AddCommentForm'
import NotapWrapper from '../../layout/NotapWrapper'
import { setCertificateDetailsGeneral, onGetSearchResultGeneral, clearResetBot, setLoadingUser, setErrorMessageUser } from '../../../config/redux/slice/appSlice'

export default function SearchResult() {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const {
        currencies
    } = useSelector((state) => state.app)
    const {
        token,
        userData: {isProfileComplete, user_role}
    } = useSelector((state) => state.authData)
    const {
        searchResult:{searchResultData, certificateSearchValue, newData}
    } = useSelector((state) => state.app)

    // useEffect(()=>{
    //   getSearchResult()
    // }, [])

    const getSearchResult = async () =>{
      const res = await getRequest(
        token,
        `${appApi.searchCertificates}/${certificateSearchValue}`,
        {},
        dispatch,
        setLoadingUser,
        "",
        setErrorMessageUser
      )
      if(res !== undefined && res.status < 400){
        let searchList = res.data.data ? [res.data.data] : []
        dispatch(onGetSearchResultGeneral(searchList))
          // navigate(appUrls.certificates_search)
      }
    }

    const setSearchResultDetails = (data, type) => {
      dispatch(setCertificateDetailsGeneral({details: data, modal: true}))
      if(user_role == 'BANK_USER'){
        if(type == 'view-details'){
         dispatch(setCertificateDetails({details: data, modal: true}))
          navigate(appUrls.bank_certificates_view)
      }
      } else if(user_role == 'TRANSFEREE_USER'){
        if(type == 'view-details'){
         dispatch(setCertificateDetailsT({details: data, modal: true}))
          navigate(appUrls.certificates_view)
      }
      }else{
        if(type == 'view-details'){
         dispatch(setCertificateDetailsN({details: data, modal: true}))
          navigate(appUrls.notap_certificates_view)
      }
      }
      //   if(type == 'view-details'){
      //    dispatch(setCertificateDetails({details: data, modal: true}))
      //     navigate(appUrls.certificates_view)
      // }
      //  else if(type == 'add-comment'){
      //    dispatch(setCertificateDetails({details: data, modal: true}))
      //   dispatch(showCommentFormFunc({modal:true}))
      // }
    }

    useEffect(()=>{
      if(newData){
          searchResultDatatable(searchResultData,setSearchResultDetails, currencies, 'searchResultTable')
          dispatch(clearResetBot())
      }    
    }, [newData])

    useEffect(()=>{
      getSearchResult()     
    }, [certificateSearchValue])

  return (
    <>{user_role == 'BANK_USER' ? 
    <BankWrapper pageTitle={'Search Result'}>
      <WrapperChildren/>
    </BankWrapper> : 
    user_role == 'TRANSFEREE_USER' ?
    <TransfereeWrapper pageTitle={'Search Result'}>
      <WrapperChildren/>
    </TransfereeWrapper> :
    <NotapWrapper pageTitle={'Search Result'}>
      <WrapperChildren/>
    </NotapWrapper>
  }</>
  )
}

    function WrapperChildren(){
      const {
        certificateManagement:{showCommentForm},
    } = useSelector((state) => state.bankUser)
      return (
        <>
        <DataTableWrapper tableID="searchResultTable" tableName='Certificate Management'>
        <thead>
            <tr>
              <th>Reference ID</th>
          <th>Certificate Number</th>
          {/* <th>Currency</th> */}
          <th>Total Amount</th>
          <th>Amount Requested</th>
          <th>Approved Amount</th>
          <th>WHT Rate</th>
          <th>Amount Available</th>
          <th>Balance</th>
          <th>Swift No</th>
          <th>Certificate Issue Date</th>
          <th>Certificate Expiry Date</th>
          <th>Certificate Effective Date</th>
          {/* <th>Comment</th> */}
          <th>Status</th>
          <th>Currency</th>
          <th>Date</th>
         <th width={'9%'}  data-orderable="false">Action</th>
            </tr>
          </thead>
          <tbody>
            
          </tbody>
        </DataTableWrapper>
        {showCommentForm && <AddCommentForm backdrop={showCommentForm}/> }
      </>
  )
    }

